import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'

import { tryToLogin } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'

import './MFAPinField.css';

class MFAPinField extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      mfa_code: '',
      thinking: props.thinking || false,
      successful: props.successful || false,
      failed: props.failed || false,
      lastSuccessful: false,
      lastFailed: false,
    }
  }


  componentDidMount(){
    if(this.state.successful){
      if(new Date().getTime() - this.state.successful < 2000){
        setTimeout((e) => {
          this.setState({
            successful: false,
            lastSuccessful: this.state.successful
          })
        }, 1000)
      } else {
        this.setState({
          successful: false,
          lastSuccessful: this.state.successful
        })
      }
    }
    if(this.state.failed){
      if(new Date().getTime() - this.state.failed < 2000){
        setTimeout((e) => {
          this.setState({
            failed: false,
            lastFailed: this.state.failed
          })
        }, 500)
      } else {
        this.setState({
          failed: false,
          lastFailed: this.state.failed
        })
      }
    }
  }


  componentWillReceiveProps(newProps){

    this.setState({
      disabled: newProps.disabled || false,
      thinking: newProps.thinking || false,
      successful: newProps.successful > this.state.lastSuccessful ? newProps.successful : false,
      failed: newProps.failed > this.state.lastFailed ? newProps.failed : false
    })

    if(newProps.successful > this.state.lastSuccessful && new Date().getTime() - newProps.successful < 2000){
      setTimeout((e) => {
        this.setState({
          successful: false,
          lastSuccessful: newProps.successful
        })
      }, 1000)
    }

    if(newProps.failed > this.state.lastFailed && new Date().getTime() - newProps.failed < 2000){
      setTimeout((e) => {
        this.setState({
          failed: false,
          lastFailed: newProps.failed
        })
      }, 500)
    }
  }


  render(){

    const { change } = this.props;

    let formDisabled = this.state.mfa_code.toString().length < 6;

    return (
      <div className={"mfa-pin-field " + (this.state.successful && " mfa-successful") + (this.state.failed && " shaking-no mfa-failed")}>
        
        <form name="MFAPinField" onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleSubmit(e);
        }}>
          <CustomField 
            type="text"
            name="mfa_code"
            placeholder="______"
            disabled={this.state.thinking}
            inline={true}
            onChange={(e) => {
              this.setState({mfa_code: e}); 
              if(e.toString().length === 6){
                this.props.onComplete(e);
                setTimeout(()=>{
                  this.setState({
                    mfa_code: ''
                  })
                  change('mfa_code', '');
                }, 10);
              }
            }}
          />
        </form>
        {
          this.state.thinking &&
          <div className="mfa-pin-field-thinking">
            <i className="fas fa-spinner-third fa-spin"/>
          </div>
        }
      </div>
    )
  }
}

MFAPinField = reduxForm({
  form: 'MFAPinField',
  enableReinitialize: true,
  destroyOnUnmount: false
})(MFAPinField)

MFAPinField = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    initialValues
  }
})(MFAPinField);

export default MFAPinField;



// WEBPACK FOOTER //
// ./src/components/MFAPinField/MFAPinField.js